<div class="transport-details-groups-dialog">

  <sc-flex vertical fitHeight stretchContent>

    <sc-flex-fitting-content vertical>
        <sc-scroll-pane>
          <sc-padding>
            <sc-content-spacer vertical></sc-content-spacer>
            <ng-container *ngFor="let group of transportExternalInformationsGroups">
              <sc-read-only-field [label]="" [value]="group.name"></sc-read-only-field>
              <sc-padding>
                <ng-container *ngFor="let entry of group.transportExternalInformationsGroupEntries">
                  <sc-read-only-field [label]="entry.key" [value]="entry.value"></sc-read-only-field>
                </ng-container>
              </sc-padding>
              <sc-content-spacer vertical></sc-content-spacer>
            </ng-container>
          </sc-padding>
        </sc-scroll-pane>
    </sc-flex-fitting-content>

  </sc-flex>

</div>

